import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Grid, Typography } from '@mui/material';

import theme from '../../utilities/theme';
import Button from '../common/styled-mui-overrides/Button';

type SubmissionSuccessMessageProps = {
  onClick: () => void;
  title: string;
  message: string;
};

const SubmissionSuccessMessage = (props: SubmissionSuccessMessageProps) => {
  return (
    <Grid container sx={styles.mainContainer}>
      <Grid item>
        <CheckCircleOutlineRoundedIcon fontSize='large' sx={styles.icon} />
      </Grid>
      <Grid item>
        <Typography variant='h6' fontWeight='bold'>
          {props.title}
        </Typography>
      </Grid>
      <Grid item>
        <Typography sx={styles.center}>{props.message}</Typography>
      </Grid>
      <Grid item sx={styles.buttonContainer}>
        <Button onClick={props.onClick}>Submit another</Button>
      </Grid>
    </Grid>
  );
};

export default SubmissionSuccessMessage;

const styles = {
  mainContainer: {
    flexDirection: 'column',
    flex: 1,
    maxWidth: 400,
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 2,
    paddingTop: 2,
    position: 'absolute',
    top: '25%',
  },
  icon: {
    color: '#259B24',
  },
  center: {
    textAlign: 'center',
    color: theme.palette.secondary.main,
  },
  buttonContainer: {
    paddingTop: 4,
  },
};
